import React from 'react';
import { Box, Flex, Image, Text, VStack } from '@chakra-ui/react';
import { ProfileImage } from 'app/components/Profile/ProfileImage';
import { useAppSelector } from 'app/store';
import { getSmallProfileImage } from 'app/store/Profile/selectors';
import { ProfileTopSectionLoader } from 'app/components/Profile/ProfileTopSectionLoader';
import { ProfileItem } from 'types/profile';
import { ChakraAvatar, ContentContainer } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';
import { ProfileNavTabs } from '../ProfileNavTabs';

export interface ProfileTopSectionProps {
  currentProfile?: ProfileItem;
  isLoading: boolean;
}

export const ProfileTopSection: React.FC<ProfileTopSectionProps> = ({
  currentProfile,
  isLoading,
}) => {
  const profileImage = useAppSelector(getSmallProfileImage);
  const profileName = currentProfile?.displayName || '';
  return (
    <Box bg="surface1" zIndex={1101}>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          w: '100%',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            h: profileImage ? 136 : 200,
            opacity: 0.36,
            filter: `blur(64px)`,
          }}
        >
          {profileImage ? (
            <Image
              src={profileImage}
              w="100%"
              h="unset"
              mt="64px"
              transform="translate(0, -50%)"
              aspectRatio="1/1"
            />
          ) : (
            <ChakraAvatar
              colors={currentProfile?.avatarColors}
              initials={currentProfile?.initials}
              size="3xl"
              w="100%"
              h="unset"
              mt="64px"
              transform="translate(0, -50%)"
              aspectRatio="1/1"
            />
          )}
        </Box>
      </Box>
      <ContentContainer type={ContentContainerType.LIST} pt={6}>
        <Flex w="full" mb={4}>
          {!currentProfile && isLoading ? (
            <ProfileTopSectionLoader />
          ) : (
            <>
              <ProfileImage
                image={profileImage}
                initials={currentProfile?.initials}
                colors={currentProfile?.avatarColors}
              />
              <VStack
                maxWidth="70%"
                alignItems="start"
                justifyContent="center"
                ml={4}
                spacing={0}
              >
                <Text
                  fontSize="xxs"
                  fontWeight={500}
                  letterSpacing={0.96}
                  lineHeight="17px"
                  color="M.70"
                  opacity={0.72}
                >
                  Profile
                </Text>
                <Text
                  fontSize="32px"
                  fontWeight={500}
                  lineHeight="43px"
                  color="M.70"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace="nowrap"
                  letterSpacing="0.5px"
                  title={profileName}
                  w="full"
                >
                  {profileName}
                </Text>
              </VStack>
            </>
          )}
        </Flex>
      </ContentContainer>
      <ProfileNavTabs />
    </Box>
  );
};
